import dayjs from 'dayjs';
import { LOGGER_LOG_TYPE, LOGGER_MESSAGE_TYPE, LOGGER_PRINT_LOGS, LOGGER_PRINT_LOGS_LEVEL, LOGGER_SEND_LOGS, LOGGER_SEND_LOGS_LEVEL, SERVER_BASE_URL, STORAGE } from '../../Config';
import Http from './Http';
import Storage from 'common/services/Storage';

class Logger {
    private systemName = '';
    private systemVersion = '';
    private appVersion = '';
    private url = SERVER_BASE_URL;
    private userId?: number;

    public setUserId(userId: number) {
        this.userId = userId;
    }

    public error(logType: LOGGER_LOG_TYPE, message: string, extraData?: any, allowSend = true): void {
        this.log(LOGGER_MESSAGE_TYPE.ERROR, logType, message, extraData, allowSend);
    }

    public info(logType: LOGGER_LOG_TYPE, message: string, extraData?: any, allowSend = true): void {
        this.log(LOGGER_MESSAGE_TYPE.INFO, logType, message, extraData, allowSend);
    }

    private log(messageType: LOGGER_MESSAGE_TYPE, logType: LOGGER_LOG_TYPE, message: string, extraData?: any, allowSend = true) {
        const data = {
            type: LOGGER_MESSAGE_TYPE[messageType],
            logType: LOGGER_LOG_TYPE[logType],
            date: dayjs.utc(new Date()).format('DD/MM/YYYY HH:mm:ss'),
            systemName: this.systemName,
            systemVersion: this.systemVersion,
            appVersion: this.appVersion,
            userId: this.userId,
            message,
            extraData,
        };

        if (LOGGER_PRINT_LOGS && messageType >= LOGGER_PRINT_LOGS_LEVEL) {
            const logMessage = `[${data.date}] ${data.message}: ${data.extraData && data.extraData.message ? data.extraData.message : ''}`;
            switch (messageType) {
                case LOGGER_MESSAGE_TYPE.INFO:
                    console.info(logMessage, data);
                    break;
                case LOGGER_MESSAGE_TYPE.ERROR:
                    console.info(logMessage, data);
                    break;
                default:
                    console.log(logMessage, data);
                    break;
            }
        }

        if (allowSend && LOGGER_SEND_LOGS  && messageType >= LOGGER_SEND_LOGS_LEVEL) {
            const logMessage = `[${data.date}] ${data.message}: ${data.extraData && data.extraData.message ? data.extraData.message : ''}`;
            const profile = Storage.getObject(STORAGE.AUTH_USER_PROFILE);            
            Http.log(logMessage, profile, { url: this.url });
        }
    }
}

export default new Logger();
